import React from 'react';
import { Link } from 'react-router-dom';
import { assetPath, company, getServiceBySlug, services } from '../../data/companyData';

const ServiceDetails = ({ slug }) => {
  const service = getServiceBySlug(slug);
  const supportImage = services.find((item) => item.slug !== service.slug)?.image || service.image;

  return (
    <section className="services-details-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-7 col-lg-7">
            <div className="services-details__content">
              <div className="services-details__img1">
                <img src={assetPath(service.image)} alt={service.title} />
              </div>

              <div className="services-details__text-box1">
                <div className="title">
                  <h2>{service.title}</h2>
                </div>
                <p className="text-1">{service.description}</p>
                <p className="text-2">
                  FA Interior Trim LLC brings more than 20 years of experience to residential and commercial projects, with a focus on quality materials, clean installation, and finishes that feel intentional.
                </p>
              </div>

              <div className="services-details__text-box2">
                <div className="row">
                  <div className="col-xl-5">
                    <div className="services-details__text-box2-img">
                      <img src={assetPath(supportImage)} alt="FA Interior Trim LLC finished work" />
                    </div>
                  </div>

                  <div className="col-xl-7">
                    <div className="services-details__text-box2-content">
                      <div className="title">
                        <h2>What We Focus On</h2>
                      </div>
                      <div className="text">
                        <p>{service.summary}</p>
                      </div>
                      <ul>
                        {service.features.slice(0, 3).map((feature) => (
                          <li key={feature}>
                            <div className="icon">
                              <span className="icon-tick"></span>
                            </div>
                            <div className="text">
                              <p>{feature}</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="services-details__text-box3">
                <p>
                  Every project is handled with direct communication, practical planning, and respect for your property. Request a free estimate to discuss scope, timing, materials, and the best way to bring your interior or exterior upgrade to life.
                </p>

                <ul>
                  {service.features.slice(3).map((feature) => (
                    <li key={feature}>
                      <div className="icon">
                        <span className="icon-tick"></span>
                      </div>
                      <div className="text">
                        <p>{feature}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-xl-5 col-lg-5">
            <div className="services-details__sidebar">
              <div className="services-details__sidebar-single services-details-category">
                <div className="title">
                  <h2>Services</h2>
                </div>
                <ul className="services-details-category-list">
                  {services.map((item) => (
                    <li key={item.slug}>
                      <Link
                        to={process.env.PUBLIC_URL + item.path}
                        className={item.slug === service.slug ? 'active' : undefined}
                      >
                        {item.title}
                        <span className="icon-right-arrow"></span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="services-details__sidebar-single services-details-contact-box">
                <div className="title">
                  <h2>Need an Estimate?</h2>
                </div>
                <p>{company.shortDescription}</p>
                <div className="number">
                  <a href={`tel:${company.phoneHref}`}>
                    <span className="icon-phone-call"></span>
                    {company.phone}
                  </a>
                </div>
              </div>

              <div className="services-details__sidebar-single services-details-button-box">
                <div className="btn-one">
                  <Link to={process.env.PUBLIC_URL + `/contact`}>
                    Request Free Estimate <span className="fa fa-arrow-right"></span>
                  </Link>
                </div>

                <div className="btn-one btn-one--two">
                  <Link to={process.env.PUBLIC_URL + `/gallery`}>
                    View Gallery <span className="fa fa-image"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetails;
